import { PAYMENT_METHOD_TYPE } from 'constants/payment';

export const isCashless = payOnDelivery =>
  !!(
    payOnDelivery &&
    payOnDelivery.items &&
    payOnDelivery.items.some(
      item => item.paymentMethod === PAYMENT_METHOD_TYPE.CASHLESS,
    )
  );

export const isCashlessOnly = payOnDelivery =>
  !!(
    payOnDelivery &&
    payOnDelivery.items &&
    payOnDelivery.items.length &&
    payOnDelivery.items.every(
      item => item.paymentMethod === PAYMENT_METHOD_TYPE.CASHLESS,
    )
  );

export const isCashOnly = payOnDelivery =>
  !!(
    payOnDelivery &&
    payOnDelivery.items &&
    payOnDelivery.items.length &&
    payOnDelivery.items.every(
      item => item.paymentMethod === PAYMENT_METHOD_TYPE.CASH,
    )
  );

export default {};
